import React from "react";
import { Box, Chip, Paper, Typography } from "@mui/material";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import PersonIcon from "@mui/icons-material/Person";

function to12h(time24) {
  if (!time24) return { h12: "12", mm: "00", period: "AM" };
  const [rawH, rawM = "00"] = time24.split(":");
  let h = parseInt(rawH, 10);
  if (isNaN(h)) return { h12: "12", mm: "00", period: "AM" };
  const period = h >= 12 ? "PM" : "AM";
  h = h % 12;
  if (h === 0) h = 12;
  return { h12: String(h), mm: rawM.padStart(2, "0"), period };
}

const fmtDate = (ymd) => {
  if (!ymd) return "—";
  const [y, m, d] = ymd.split("-");
  if (!y || !m || !d) return ymd;
  return `${d}-${m}-${y}`;
};

const fmtTime = (t) => {
  if (!t) return "";
  const { h12, mm, period } = to12h(t.substring(0, 5));
  return `${h12}:${mm} ${period}`;
};

const PastTripCard = ({ trip, index }) => {
  return (
    <Paper
      variant="outlined"
      sx={{
        p: 1.5,
        mb: 1.5,
        borderRadius: 2,
        borderColor: "#e0e0e0",
        backgroundColor: "#fafafa",
        "&:hover": { borderColor: "#1976d2", backgroundColor: "#f0f7ff" },
        transition: "all 0.2s",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 0.75,
        }}
      >
        <Chip
          label={trip.bookingId || "—"}
          size="small"
          sx={{
            fontSize: "0.65rem",
            height: 18,
            fontWeight: 700,
            backgroundColor: "#e3f2fd",
            color: "#1565c0",
          }}
        />
        <Chip
          label={trip.bookingType === "E" ? "Enquiry" : "Booking"}
          size="small"
          color={trip.bookingType === "B" ? "success" : "warning"}
          sx={{ fontSize: "0.6rem", height: 18 }}
        />
      </Box>
      {trip.vehicleType && (
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mb: 0.5 }}>
          <DirectionsCarIcon sx={{ fontSize: 13, color: "#666" }} />
          <Typography variant="caption" sx={{ color: "#444", fontWeight: 600 }}>
            {trip.vehicleType}
          </Typography>
        </Box>
      )}
      {trip.driverName && (
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mb: 0.5 }}>
          <PersonIcon sx={{ fontSize: 13, color: "#666" }} />
          <Typography variant="caption" sx={{ color: "#444" }}>
            {trip.driverName}
            {trip.driverPhone ? ` · ${trip.driverPhone}` : ""}
            {trip.vehicleCode ? (
              <>
                {" · "}
                <DirectionsCarIcon sx={{ fontSize: 13, color: "#666" }} />{" "}
                {trip.vehicleCode}
              </>
            ) : null}
          </Typography>
        </Box>
      )}
      <Box sx={{ mb: 0.5 }}>
        <Typography
          variant="caption"
          sx={{
            color: "#888",
            fontSize: "0.65rem",
            fontWeight: 700,
            textTransform: "uppercase",
            letterSpacing: 0.5,
          }}
        >
          Trip Details
        </Typography>
        <Typography
          variant="caption"
          sx={{ display: "block", color: "#333", fontSize: "0.72rem" }}
        >
          {trip.tripDetails || "—"}
        </Typography>
        <Typography
          variant="caption"
          sx={{ color: "#999", fontSize: "0.65rem" }}
        >
          {fmtDate(trip.pickupDate)} {fmtTime(trip.pickupTime)}
        </Typography>
      </Box>
      {/* {(trip.dropAddress || trip.dropDate) && (
        <Box sx={{ mb: 0.5 }}>
          <Typography
            variant="caption"
            sx={{
              color: "#888",
              fontSize: "0.65rem",
              fontWeight: 700,
              textTransform: "uppercase",
              letterSpacing: 0.5,
            }}
          >
            Drop
          </Typography>
          <Typography
            variant="caption"
            sx={{ display: "block", color: "#333", fontSize: "0.72rem" }}
          >
            {trip.dropAddress || "—"}
          </Typography>
          <Typography
            variant="caption"
            sx={{ color: "#999", fontSize: "0.65rem" }}
          >
            {fmtDate(trip.dropDate)} {fmtTime(trip.dropTime)}
          </Typography>
        </Box>
      )} */}
      {/* {trip.quote && parseFloat(trip.quote) > 0 && (
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 0.5 }}>
          <Typography
            variant="caption"
            sx={{ fontWeight: 700, color: "#2e7d32", fontSize: "0.72rem" }}
          >
            ₹{parseFloat(trip.quote).toLocaleString()}
          </Typography>
        </Box>
      )} */}
      {trip.paymentDetails && (
        <Box
          sx={{
            mt: 0.75,
            p: 0.75,
            backgroundColor: "#fff8e1",
            borderRadius: 1,
            border: "1px solid #ffe082",
          }}
        >
          <Typography
            variant="caption"
            sx={{
              color: "#888",
              fontSize: "0.65rem",
              fontWeight: 700,
              textTransform: "uppercase",
            }}
          >
            Payment Details
          </Typography>
          <Typography
            variant="caption"
            sx={{
              display: "block",
              color: "#555",
              fontStyle: "italic",
              fontSize: "0.72rem",
            }}
          >
            "{trip.paymentDetails}"
          </Typography>
        </Box>
      )}
      {trip.feedback && (
        <Box
          sx={{
            mt: 0.75,
            p: 0.75,
            backgroundColor: "#fff8e1",
            borderRadius: 1,
            border: "1px solid #ffe082",
          }}
        >
          <Typography
            variant="caption"
            sx={{
              color: "#888",
              fontSize: "0.65rem",
              fontWeight: 700,
              textTransform: "uppercase",
            }}
          >
            Feedback
          </Typography>
          <Typography
            variant="caption"
            sx={{
              display: "block",
              color: "#555",
              fontStyle: "italic",
              fontSize: "0.72rem",
            }}
          >
            "{trip.feedback}"
          </Typography>
        </Box>
      )}
    </Paper>
  );
};

export default PastTripCard;
